/*eslint-disable*/
import React, { useCallback, useState } from 'react'
import 'video-react/dist/video-react.css'
import { Player } from 'video-react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { withRouter } from 'react-router'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import { Container, Button, Modal, Form, Input, InputGroupAddon, InputGroupText, InputGroup } from 'reactstrap'
import logoMural from 'assets/img/logo_mural.png'
import Video from 'assets/img/VideoExplainer.mp4'
import ErrorText from 'components/Texts/ErrorText'
import { ValidationHelper } from 'helpers/validation'

const schema = yup.object().shape({
  NomeInscrito: yup
    .string()
    .required('Por favor, informe o nome do estudante')
    .matches(ValidationHelper.onlyLetters, 'Apenas letras são permitidas')
    .nullable(),
})

const IndexHeader = ({ history }) => {
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false)

  const { errors, register, handleSubmit } = useForm({ resolver: yupResolver(schema) })
  const { executeRecaptcha } = useGoogleReCaptcha()

  const onSubmit = useCallback(
    async (value) => {
      const Captcha = await executeRecaptcha('cadastro_pagina')
      history.push(`/consulta-aprovados-sisu/${value.NomeInscrito}?Captcha=${Captcha}`)
    },
    [history]
  )

  return (
    <>
      <div
        id="principal"
        className="page-header section-dark"
        style={{
          backgroundImage: 'url(' + require('assets/img/Bg_Landing.jpg') + ')',
        }}
      >
        <div className="content-center">
          <Container>
            <div className="title-brand" style={{ marginBottom: 20, marginTop: 20 }}>
              <img src={logoMural} style={{ width: 240 }} />
            </div>
            <div className="title-brand">
              <h4
                className="presentation-title"
                style={{
                  color: '#FFF',
                  letterSpacing: 4,
                  lineHeight: 1.5,
                  fontSize: 32,
                }}
              >
                Tem dificuldade em descobrir se seus alunos foram aprovados?
              </h4>
            </div>
            <h2
              className="presentation-subtitle text-center"
              style={{
                color: '#FFF',
                letterSpacing: 4,
                fontSize: 14,
                lineHeight: 2,
                marginTop: 10,
              }}
            >
              Aqui no Mural de Aprovados Sisu você tem essa resposta em poucos minutos.
            </h2>
            <br />
            <div align="center" style={{ marginTop: 0 }}>
              <Button
                style={{
                  color: '#FFF',
                  letterSpacing: 4,
                  fontSize: 14,
                  textTransform: 'none',
                }}
                onClick={() => setIsVideoModalVisible(true)}
                className="btn-round mr-1"
                color="neutral"
                outline
              >
                <i className="fa fa-play" />
                Assista o vídeo
              </Button>{' '}
              <Button
                href="#cadastro"
                className="btn-round"
                color="danger"
                type="button"
                to="cadastro"
                spy
                smooth
                offset={-70}
                duration={700}
                style={{
                  color: '#FFF',
                  letterSpacing: 4,
                  fontSize: 14,
                  textTransform: 'none',
                }}
              >
                Cadastre-se
              </Button>
            </div>

            <Modal
              isOpen={isVideoModalVisible}
              className="modal-lg"
              modalClassName="bd-example-modal-lg"
              toggle={() => setIsVideoModalVisible(false)}
            >
              <div>
                <Player style={{ borderRadius: 20, marginTop: -200 }} autoPlay playsInline src={Video} />
              </div>
            </Modal>

            <div
              className="title-brand"
              style={{
                marginTop: 20,
                letterSpacing: 4,
                fontWeight: 600,
                fontSize: 22,
              }}
            >
              Consulta rápida
            </div>
            <div className="title-brand" style={{ marginTop: 0, letterSpacing: 4, fontSize: 10 }}>
              Digite o nome do aluno
            </div>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="title-brand" style={{ marginTop: 15 }}>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText
                      style={{
                        borderRadius: 20,
                        marginRight: 10,
                        height: 45,
                        paddingLeft: 19,
                        paddingRight: 20,
                      }}
                    >
                      <i className="nc-icon nc-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    innerRef={register}
                    id="NomeInscrito"
                    name="NomeInscrito"
                    placeholder="Digite o nome completo do estudante"
                    type="text"
                    style={{
                      borderRadius: 20,
                      height: 45,
                      paddingLeft: 20,
                      letterSpacing: 3,
                    }}
                  />
                </InputGroup>
                <ErrorText errors={errors} name="NomeInscrito" textColor="#fff" />
              </div>
              <div className="title-brand" style={{ marginTop: 12, letterSpacing: 4, marginBottom: 0 }}>
                <Button
                  disabled={Object.values(errors).length > 0}
                  className="btn-round"
                  color="danger"
                  style={{
                    paddingTop: 10,
                    paddingBottom: 5,
                    fontSize: 16,
                    letterSpacing: 4,
                    textTransform: 'none',
                    color: '#FFF',
                    border: 0,
                    width: '100%',
                    height: 45,
                    borderRadius: 20,
                  }}
                >
                  <i className="nc-icon nc-zoom-split" style={{ height: 18 }} /> Consultar
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      </div>
    </>
  )
}

export default withRouter(IndexHeader)
